import gql from 'graphql-tag';

export const listMembershipGql = gql`
  query (
    $inst_id: String!
    $account_id: String!
    $user_key: String!
    $page: Int!
    $size: Int!
    $sort: String!
  ) {
    audienceListMemberShip(
      instId: $inst_id
      accountId: $account_id
      userKeyConsolidated: $user_key
      page: $page
      size: $size
      sort: $sort
    ) {
      page
      totalPages
      totalRecords
      recordsPerPage
      lists: list {
        name
        createUser
        createdAt
      }
    }
  }
`;

export const profileHeaderGql = gql`
  query ($inst_id: String!, $audience_key: String!) {
    audience {
      audience(inst_id: $inst_id, userKeyConsolidated: $audience_key) {
        profile {
          firstName
          lastName
          birthDate
          gender
          currentHighSchool: currentSchool
          intendedEntryTerm: enrollTerm
          interestedMajor: major
          email
          phoneNumber: phone
          country
          zipcode: postal
          unweightedGPA: gpa
          sat
          act
          visitorType
          relativeInterestLevel
          lastDateActiveWithYouvisit
          lastDateActiveWithInstitution
        }
      }
    }
  }
`;
